module.exports = __webpack_public_path__ + "media/slide.6160d031.wav";